module.exports = Object.setPrototypeOf;